class AnimatedValue {
	__value: number;
	constructor(val: number) {
		this.__value = val;
	}
}

export default AnimatedValue;
